import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import './login-success-page.scss';

export default class LoginSuccessPage extends Component {
  render() {
    return (
      <div className="inscriereSuccess error-page-sec pt-100 pb-100">
        <div className="container">
          <div className="row">
            <div className="col-md-3" />
            <div className="col-md-6">
              <div className="error-page-content">
                <h1>Felicitari</h1>
                <h2>Logarea a fost efectuata cu success</h2>
                <div className="inscriereSuccess-icon fa fa-check-circle" />
                <Link to="/">Inapoi la site</Link>
              </div>
            </div>
            <div className="col-md-3" />
          </div>
        </div>
      </div>
    );
  }
}
